import { VueMaskFilter } from 'v-mask';
import FormPhoneTooltip from '~/components/members-area/FormPhoneTooltip.vue';
export default {
  name: 'FormPersonalInfo',
  components: {
    FormPhoneTooltip
  },
  filters: {
    VMask: VueMaskFilter
  },
  props: {
    form: {
      type: Object,
      required: true
    },
    formErrors: {
      type: Object,
      required: true
    },
    showEmailTooltip: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      editName: !this.form.first_name || !this.form.last_name,
      editEmail: !this.form.email
    };
  },
  computed: {
    inputForm: {
      get() {
        return this.form;
      },
      set(newVal) {
        this.$emit('update:form', newVal);
      }
    },
    nameDisabled() {
      return this.formErrors.first_name || this.formErrors.last_name;
    },
    emailDisabled() {
      return this.formErrors.email;
    }
  },
  mounted() {
    if (!this.form.first_name) {
      this.$emit('onFieldBlur', 'first_name');
    }
    if (!this.form.last_name) {
      this.$emit('onFieldBlur', 'last_name');
    }
    if (!this.form.email) {
      this.$emit('onFieldBlur', 'email');
    }
  },
  methods: {
    emailClicked() {
      this.$emit('update:showEmailTooltip', false);
      this.editEmail = true;
    }
  }
};